import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  initials: 'VT',
  name: 'Valeria T.',
  role: 'Docente de Historia | Ciudad de México, México',
  text: 'El material sobre la Conquista le cambió la cara a mis alumnos. Por fin entienden que no fue una historia simple de buenos y malos. Es el recurso más honesto y completo que encontré para este tema. Lo uso desde la primera clase y los engancha de inmediato.'
}, {
  initials: 'CR',
  name: 'Carlos R.',
  role: 'Profesor de Historia | Guadalajara, México',
  text: 'El banco de evaluaciones vale por sí solo el precio del pack. Nunca más construí un examen desde cero bajo presión. Salgo de cada ciclo escolar con la satisfacción de tener todo resuelto.'
}, {
  initials: 'DG',
  name: 'Diana G.',
  role: 'Docente de secundaria | Monterrey, México',
  text: 'Los proyectos integradores transformaron el grupo más difícil que tenía. Los alumnos conectaron la Revolución Mexicana con el México actual y no podían parar de debatir. Eso no lo encontré en ningún otro material.'
}, {
  initials: 'AM',
  name: 'Andrés M.',
  role: 'Docente universitario | Puebla, México',
  text: 'El glosario me devolvió el tiempo de clase. Antes perdía los primeros veinte minutos explicando términos como calpulli o encomienda. Ahora mis alumnos llegan con el glosario leído y podemos ir directo al análisis.'
}, {
  initials: 'SR',
  name: 'Sandra R.',
  role: 'Profesora de Historia | Oaxaca, México',
  text: 'Los recursos de pensamiento histórico fueron una revelación. Mis alumnos ya no me preguntan para qué sirve estudiar historia. Ahora ellos mismos encuentran las conexiones con lo que pasa hoy — y eso cambió completamente la dinámica de mis clases.'
}];
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-ivory" data-id="element-64">
      <div className="max-w-6xl mx-auto" data-id="element-65">
        <div className="text-center mb-16" data-id="element-66">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-forest" data-id="element-67">
            Lo que dicen los docentes que ya tienen su Mega Pack
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-68">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-white border border-beige p-8 rounded-2xl relative shadow-sm ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-69">
              <Quote className="absolute top-6 right-6 text-gold/20" size={48} data-id="element-70" />

              <div className="flex gap-1 text-gold mb-6" data-id="element-71">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-72" />)}
              </div>

              <p className="text-ink italic mb-8 relative z-10 leading-relaxed font-medium" data-id="element-73">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-74">
                <div className="w-12 h-12 rounded-full bg-forest/10 border border-forest/20 flex items-center justify-center text-forest font-bold text-lg" data-id="element-75">
                  {t.initials}
                </div>
                <div data-id="element-76">
                  <div className="font-bold text-ink" data-id="element-77">{t.name}</div>
                  <div className="text-xs text-terracotta" data-id="element-78">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}